import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import {
  ClickableIcon, SecondaryTextLgBold, SecondaryTextSm,
} from 'atoms';
import {
  MobileSidebarFilterWrapper, FlexBoxWrapper, P4, CustomBackgroundWrapper, FlexCenterWrapper,
  Ml2, GenericWrapper, Mt2, NotPaddedGrowWrapper, Mt3, MediaListScrollWrapper, Mb2, Mt4,
  BorderBottomWrapper, Mt10,
} from 'wrappers';
import { SolidButton, TabButton } from 'molecules';
import { XSvg, BackArrowSvg } from 'components/icons';
import DatePickerButtons from '../datePickerButtons';
import { getSelectedTimeSpanName, getSelectedTimeSpanByDate } from 'utils';
import CustomCalendarHeaderInputs from '../customCalendarHeaderInputs';
import React from 'react';
import CalendarMonth from '../calendarMonth';

const yearListRef = React.createRef();
const monthListRef = React.createRef();

export const definition = {
  name: 'MobileSideDatePicker',
  controller: Controller,
  initialProps: ({ isVisible, startDate, endDate }) => ({ isVisible, startDate, endDate, selectedTimeSpan: startDate || endDate ? getSelectedTimeSpanByDate({ startDate, endDate }) : '' }),
  props: internalState,
  elements: [
    {
      wrapper: MobileSidebarFilterWrapper,
      name: 'Wrapper',
      displayState: ({ isVisible }) => ({ isVisible, hideBackground: true }),
      elements: [
        {
          wrapper: FlexBoxWrapper,
          name: 'Wrapper',
          elements: [
            {
              component: wrap(ClickableIcon, P4),
              name: 'CloseIcon',
              bindings: ({ startDate, endDate, selectedTimeSpan }) => ({ startDate, endDate, selectedTimeSpan }),
              displayValue: ({ }) => XSvg({ width: 24, height: 24, color: '#FFFFFF' })
            },
            {
              wrapper: CustomBackgroundWrapper,
              name: 'ButtonsWrapper',
              displayState: ({ }) => ({ flexDirection: 'column', width: 'calc(100% - 64px)', height: '100vh', background: '#FFFFFF' }),
              elements: [
                {
                  wrapper: wrap(FlexBoxWrapper, P4),
                  name: 'TitleWrapper',
                  elements: [
                    {
                      component: wrap(ClickableIcon, Mt2),
                      name: 'GoBack',
                      bindings: ({ startDate, endDate, selectedTimeSpan }) => ({ startDate, endDate, selectedTimeSpan }),
                      displayValue: ({ }) => BackArrowSvg({})
                    },
                    {
                      wrapper: wrap(GenericWrapper, Ml2),
                      name: 'TitleWrapper',
                      elements: [
                        {
                          component: SecondaryTextLgBold,
                          name: 'Title',
                          displayValue: ({ }) => 'Date'
                        },
                        {
                          component: SecondaryTextSm,
                          name: 'TimeSpan',
                          displayValue: ({ selectedTimeSpan, startDate, endDate }) => selectedTimeSpan === 'custom' ? 'Custom' : getSelectedTimeSpanName({ selectedTimeSpan, startDate, endDate })
                        },
                      ]
                    }
                  ]
                },
                {
                  component: CustomCalendarHeaderInputs,
                  renderIf: ({ openCalendar }) => openCalendar,
                  name: 'CustomHeader',
                  bindings: ({ startDate, endDate, editingDate }) => ({ startDate, endDate, editingDate })
                },
                {
                  wrapper: wrap(MediaListScrollWrapper, BorderBottomWrapper),
                  name: 'YearList',
                  renderIf: ({ openCalendar }) => openCalendar,
                  ref: yearListRef,
                  elements: [
                    {
                      component: wrap(wrap(TabButton, Mb2), Mt4),
                      isListOf: { year: ({ }) => Array.from(Array(60).keys()) },
                      name: 'Year',
                      bindings: ({ year, startDate, endDate }) => ({ title: (year + 2000).toString(), year: year + 2000, startDate, endDate, monthListRef }),
                      displayState: ({ selectedYear, year }) => ({ fontSize: 12, selected: selectedYear === (year + 2000) })
                    },
                  ]
                },
                {
                  wrapper: NotPaddedGrowWrapper,
                  name: 'ListWrapper',
                  renderIf: ({ openCalendar }) => openCalendar,
                  ref: monthListRef,
                  elements: [
                    {
                      component: wrap(CalendarMonth, Mt10),
                      isListOf: { month: ({ }) => Array.from(Array(12).keys()) },
                      name: 'Month',
                      bindings: ({ month, selectedYear, startDate, endDate, selectedTimeSpan, editingDate }) => {
                        return {
                          year: selectedYear,
                          month,
                          selectedDates: [startDate, endDate],
                          selectedPeriod: [startDate, endDate],
                          startDate, endDate, selectedTimeSpan, editingDate
                        }
                      }
                    }
                  ]
                },
                {
                  wrapper: NotPaddedGrowWrapper,
                  name: 'OptionsWrapper',
                  renderIf: ({ openCalendar }) => !openCalendar,
                  elements: [
                    {
                      component: wrap(DatePickerButtons, Mt3),
                      name: 'Buttons',
                      bindings: ({ startDate, endDate, selectedTimeSpan }) => ({ startDate, endDate, selectedTimeSpan, displayIcon: true, yearListRef, monthListRef })
                    },
                  ]
                },
                {
                  component: wrap(wrap(SolidButton, FlexCenterWrapper), P4),
                  name: 'Button',
                  bindings: ({ startDate, endDate, selectedTimeSpan }) => ({ startDate, endDate, selectedTimeSpan, title: `Apply filters` }),
                },
              ]
            }
          ]
        }
      ]
    }
  ]
};

export default ContainerComponent(definition);